import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.333 5.453V2A.667.667 0 1 0 12 2v3.453a2 2 0 0 0 0 3.76V14a.666.666 0 1 0 1.333 0V9.213a2 2 0 0 0 0-3.76M12.667 8a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333m-4 1.453V2a.667.667 0 0 0-1.334 0v7.453a2 2 0 0 0 0 3.76V14a.667.667 0 1 0 1.334 0v-.787a2 2 0 0 0 0-3.76M8 12a.667.667 0 1 1 0-1.334A.667.667 0 0 1 8 12M4 4.12V2a.667.667 0 0 0-1.333 0v2.12a2 2 0 0 0 0 3.76V14A.667.667 0 1 0 4 14V7.88a2 2 0 0 0 0-3.76m-.667 2.547a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })